export const TITLE_TEXT = 'mobile_view_message';
